import { CheckCircle, AlertCircle, Info, AlertTriangle, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useToastStore } from '../../store/useToastStore';

export default function ToastContainer() {
  const { toasts, hideToast } = useToastStore();

  const styles = {
    success: {
      bg: 'bg-green-500',
      icon: CheckCircle,
      iconColor: 'text-white'
    },
    error: {
      bg: 'bg-red-500',
      icon: AlertCircle,
      iconColor: 'text-white'
    },
    info: {
      bg: 'bg-blue-500',
      icon: Info,
      iconColor: 'text-white'
    },
    warning: {
      bg: 'bg-yellow-500',
      icon: AlertTriangle,
      iconColor: 'text-white'
    }
  };

  return (
    <div className="fixed bottom-8 left-0 right-0 z-[9999] flex flex-col items-center gap-2 pointer-events-none">
      <AnimatePresence>
        {toasts.map((toast) => {
          const { bg, icon: Icon, iconColor } = styles[toast.type];
          
          return (
            <motion.div
              key={toast.id}
              layout
              initial={{ opacity: 0, y: 20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.95 }}
              transition={{ 
                duration: 0.2,
                ease: "easeOut",
                layout: { duration: 0.2, ease: "easeOut" }
              }}
              className="pointer-events-auto max-w-2xl w-auto"
            >
              <div className={`${bg} text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3`}>
                <Icon className={`w-5 h-5 flex-shrink-0 ${iconColor}`} />
                <span className="font-medium">{toast.message}</span>
                <button
                  onClick={() => hideToast(toast.id)}
                  className="ml-2 hover:opacity-75 transition-opacity"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}

